<template>
  <page-layout title="개인 실적">
    <template v-slot:search>
      <loan-performance-min-search-bar
        @search="getSearch"
      />
    </template>
    <template v-slot:table>
      <loan-performance-mine-detail
        :data="data"
        :loading="loading"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import LoanPerformanceMinSearchBar from "@/pages/Loan/components/LoanPerformanceMine/LoanPerformanceMineSearchBar.vue";
import {axiosInstance} from "@/util/AxiosModule";
import LoanPerformanceMineDetail from "@/pages/Loan/components/LoanPerformanceMine/LoanPerformanceMineDetail.vue";
import _ from "lodash";

export default {
  name: "LoanPerformanceMine",
  components: {LoanPerformanceMineDetail, LoanPerformanceMinSearchBar, PageLayout},
  data() {
    return {
      data: {},
      loading: false
    }
  },
  methods: {
    async getSearch(params) {
      try {
        const { data } = await axiosInstance.get("/private/performance/performance", { params });
        if (_.isEmpty(data)) {
          this.data = {};
        } else {
          this.data = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    }
  }
}
</script>